import React from 'react';
import {connect} from "react-redux";
import Select from 'react-select';
import Pagination from 'react-js-pagination';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import {contains, isEqual} from 'underscore';

import {
    changePage,
    setPageSize,
    releaseScheduledReplenishment,
    deleteScheduledReplenishment,
    deleteScheduledReplenishments,
    fetchScheduledReplenishments,
    updateQuery,
    updateStatusFilter,
    updateSortProperty
} from "./reducer";

import ScheduledReplenishmentItem from './ScheduledReplenishmentItem';

import ResultCount from '../components/List/ResultCount';
import SearchField from '../components/SearchField';
import MultiSortableTableHeader from "../components/MultiSortableTableHeader";

export class ScheduledReplenishmentManager extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            dropdownMenuOpen: false,
            selectedItems: {}
        };
        this.handleQueryChange = this.handleQueryChange.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.applyStatusFilter = this.applyStatusFilter.bind(this);
        this.toggleItemSelection = this.toggleItemSelection.bind(this);
        this.toggleAllItems = this.toggleAllItems.bind(this);
        this.toggleDropDownMenu = this.toggleDropDownMenu.bind(this);
        this.bulkDeleteScheduledReplenishments = this.bulkDeleteScheduledReplenishments.bind(this);
    }

    handlePageChange(newPage) {
        this.props.changePage(newPage - 1);
    }

    handleQueryChange(query) {
        this.props.updateQuery(query);
    }

    applyStatusFilter(filterOption) {
        this.props.updateStatusFilter(filterOption.value);
    };

    componentDidMount() {
        this.props.fetchScheduledReplenishments();
    }

    toggleItemSelection(id) {
        let selectedItems = this.state.selectedItems;
        if(contains(selectedItems, id)) {
            delete selectedItems[id];
        } else {
            selectedItems[id] = id;
        }
        this.setState({
            selectedItems: selectedItems
        });
    }

    toggleAllItems() {
        if(Object.keys(this.state.selectedItems).length > 0) {
            this.setState({
                selectedItems: {}
            });
        } else {
            let selectedItems = this.props.replenishments.reduce((map, replenishment) => {
                map[replenishment.id] = replenishment.id;
                return map;
            }, {});
            this.setState({
                selectedItems: selectedItems
            });
        }
    }

    toggleDropDownMenu() {
        this.setState(prevState => ({
            dropdownMenuOpen: !prevState.dropdownMenuOpen
        }));
    }

    bulkDeleteScheduledReplenishments() {
        const idsToDelete = Object.keys(this.state.selectedItems);
        this.props.deleteScheduledReplenishments(idsToDelete);
    }

    componentDidUpdate(prevProps) {
        if(!isEqual(this.props.replenishments, prevProps.replenishments)) {
            this.setState({
                selectedItems: {}
            });
        }
    }

    render() {

        const statusFilterOptions = [
            {value: 'ALL', label: 'alle'},
            {value: 'RELEASED', label: 'released'},
            {value: 'OPEN', label: 'offen'}
        ];

        const selectedStatusOption = statusFilterOptions.find(option => option.value === this.props.filters.processingStatus);

        return (
            <div className="animated fadeIn" style={{fontSize: 'x-small'}}>
                <div className="card">
                    <div className="card-body">
                        <h4 className="card-title">Geplante Nachversorgungen</h4>
                        <div className="row">
                            <div className="col-2">
                                <Select
                                    name="status"
                                    value={selectedStatusOption}
                                    onChange={this.applyStatusFilter}
                                    options={statusFilterOptions}
                                />
                            </div>
                            <div className="col-3">
                                <SearchField className="mb-2 mr-sm-2 mb-sm-0" value={this.props.query} onCommit={this.handleQueryChange}/>
                            </div>
                            <div className="col-lg-7">
                                <Dropdown isOpen={this.state.dropdownMenuOpen} toggle={this.toggleDropDownMenu} className="float-right">
                                    <DropdownToggle caret>
                                        ...weitere Aktionen
                                    </DropdownToggle>
                                    <DropdownMenu>
                                        <DropdownItem onClick={this.bulkDeleteScheduledReplenishments}>geplante Nachversorgung löschen</DropdownItem>
                                    </DropdownMenu>
                                </Dropdown>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <ResultCount start={(this.props.pagination.page) * this.props.pagination.pageSize + 1}
                                             end={(this.props.pagination.page) * this.props.pagination.pageSize + this.props.replenishments.length}
                                             total={this.props.pagination.totalElements}/>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <table className="table table-striped">
                                    <thead>
                                    <tr>
                                        <th style={{verticalAlign: 'middle'}}>
                                            <input name="selectItem" type="checkbox" checked={Object.keys(this.state.selectedItems).length > 0}
                                                   onChange={this.toggleAllItems}/>
                                        </th>
                                        <MultiSortableTableHeader
                                                sortProperties={[{sortProperty: "id", sortPropertyName: "ID"}]}
                                                propertyToSortBy={this.props.sortProperties.propertyToSortBy}
                                                sortDirection={this.props.sortProperties.sortDirection}
                                                updateSortProperty={this.props.updateSortProperty}/>
                                        <MultiSortableTableHeader
                                                sortProperties={[{sortProperty: "createdAt", sortPropertyName: "Eingegangen"}]}
                                                propertyToSortBy={this.props.sortProperties.propertyToSortBy}
                                                sortDirection={this.props.sortProperties.sortDirection}
                                                updateSortProperty={this.props.updateSortProperty}/>
                                        <th>Letzte Bestandsakt.</th>
                                        <th>Flächenbestand</th>
                                        <MultiSortableTableHeader
                                                sortProperties={[{sortProperty: "currentStockQuantity", sortPropertyName: "NV-Bestand"}]}
                                                propertyToSortBy={this.props.sortProperties.propertyToSortBy}
                                                sortDirection={this.props.sortProperties.sortDirection}
                                                updateSortProperty={this.props.updateSortProperty}/>
                                        <th>letzte NV</th>
                                        <MultiSortableTableHeader
                                                sortProperties={[{sortProperty: "retailerGln", sortPropertyName: "Händler-GLN"},
                                                                 {sortProperty: "retailerName", sortPropertyName: "Händler"}]}
                                                propertyToSortBy={this.props.sortProperties.propertyToSortBy}
                                                sortDirection={this.props.sortProperties.sortDirection}
                                                updateSortProperty={this.props.updateSortProperty}/>
                                        <MultiSortableTableHeader
                                                sortProperties={[{sortProperty: "storeGln", sortPropertyName: "Filial-GLN"},
                                                                 {sortProperty: "storeZipCode", sortPropertyName: "PLZ"},
                                                                 {sortProperty: "storeCity", sortPropertyName: "Ort"}]}
                                                propertyToSortBy={this.props.sortProperties.propertyToSortBy}
                                                sortDirection={this.props.sortProperties.sortDirection}
                                                updateSortProperty={this.props.updateSortProperty}/>
                                        <MultiSortableTableHeader
                                                sortProperties={[{sortProperty: "moduleName", sortPropertyName: "Modul"}]}
                                                propertyToSortBy={this.props.sortProperties.propertyToSortBy}
                                                sortDirection={this.props.sortProperties.sortDirection}
                                                updateSortProperty={this.props.updateSortProperty}/>
                                        <MultiSortableTableHeader
                                                sortProperties={[{sortProperty: "articleBrand", sortPropertyName: "Marke"}]}
                                                propertyToSortBy={this.props.sortProperties.propertyToSortBy}
                                                sortDirection={this.props.sortProperties.sortDirection}
                                                updateSortProperty={this.props.updateSortProperty}/>
                                        <MultiSortableTableHeader
                                                sortProperties={[{sortProperty: "articleErpIdno", sortPropertyName: "ERP-Artikelnr."},
                                                    {sortProperty: "articleGtin", sortPropertyName: "GTIN"},
                                                    {sortProperty: "articleName", sortPropertyName: "Details"}]}
                                                propertyToSortBy={this.props.sortProperties.propertyToSortBy}
                                                sortDirection={this.props.sortProperties.sortDirection}
                                                updateSortProperty={this.props.updateSortProperty}/>
                                        <MultiSortableTableHeader
                                                sortProperties={[{sortProperty: "articleVendorArticleNumber", sortPropertyName: "Hersteller-Artikelnr."}]}
                                                propertyToSortBy={this.props.sortProperties.propertyToSortBy}
                                                sortDirection={this.props.sortProperties.sortDirection}
                                                updateSortProperty={this.props.updateSortProperty}/>
                                        <th>NV-Menge</th>
                                        <th>Aktionen</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {this.props.replenishments.map((replenishment, index) => {
                                        return <ScheduledReplenishmentItem {...replenishment}
                                                                           isSelected={contains(this.state.selectedItems, replenishment.id)}
                                                                           selectItem={this.toggleItemSelection}
                                                                           releaseScheduledReplenishment={this.props.releaseScheduledReplenishment}
                                                                           deleteScheduledReplenishment={this.props.deleteScheduledReplenishment}
                                                                           key={replenishment.id}/>;
                                    })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <Pagination
                                    activePage={this.props.pagination.page + 1}
                                    itemsCountPerPage={this.props.pagination.pageSize}
                                    totalItemsCount={this.props.pagination.totalElements}
                                    pageRangeDisplayed={20}
                                    onChange={this.handlePageChange}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-2 pull-left">
                                <Select
                                    name="pageSize"
                                    value={this.props.pagination.pageSize}
                                    onChange={(select) => this.props.setPageSize(select.value)}
                                    options={[
                                        {value: '25', label: '25'},
                                        {value: '50', label: '50'},
                                        {value: '100', label: '100'},
                                        {value: '200', label: '200'},
                                        {value: '1000', label: '1000'}
                                    ]}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <ResultCount start={(this.props.pagination.page) * this.props.pagination.pageSize + 1}
                                             end={(this.props.pagination.page) * this.props.pagination.pageSize + this.props.replenishments.length}
                                             total={this.props.pagination.totalElements}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {

    return {
        replenishments: state.scheduledReplenishment.get('replenishments').toJS(),
        sortProperties: state.scheduledReplenishment.get('sortProperties').toJS(),
        filters: state.scheduledReplenishment.get('filters').toJS(),
        query: state.scheduledReplenishment.get('query'),
        pagination: state.scheduledReplenishment.get('pagination').toJS()
    };
}

const ConnectedScheduledReplenishmentManager = connect(mapStateToProps, {
    changePage,
    setPageSize,
    releaseScheduledReplenishment,
    deleteScheduledReplenishment,
    deleteScheduledReplenishments,
    fetchScheduledReplenishments,
    updateQuery,
    updateStatusFilter,
    updateSortProperty
})(ScheduledReplenishmentManager);

export default ConnectedScheduledReplenishmentManager;



// WEBPACK FOOTER //
// ./src/admin/scheduledreplenishment/ScheduledReplenishmentManager.js